import React, { useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Chart } from "primereact/chart";
import type { WeeklyStationMetric } from "../../../types/kpiDashboard";

interface Props {
  visible: boolean;
  onHide: () => void;
  trend: WeeklyStationMetric[];
}

const SessionsDetailDialog: React.FC<Props> = ({ visible, onHide, trend }) => {
  const chartData = useMemo(() => ({
    labels: trend.map((d) => d.period),
    datasets: [
      {
        label: "Total Sessions",
        data: trend.map((d) => d.sessionsTotal),
        borderColor: "#8b5cf6",
        backgroundColor: "rgba(139,92,246,0.12)",
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointBackgroundColor: "#8b5cf6",
      },
      // BOF-76: the free-session count was previously mapped onto "daily sessions" and so had no
      // label of its own. It is a share of the total above, so it is drawn against the same axis.
      {
        label: "Free Sessions",
        data: trend.map((d) => d.freeSessions),
        borderColor: "#f59e0b",
        backgroundColor: "rgba(245,158,11,0.12)",
        tension: 0.4,
        fill: true,
        pointRadius: 4,
        pointBackgroundColor: "#f59e0b",
      },
    ],
  }), [trend]);

  const chartOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 300 },
    interaction: { mode: "index" as const, intersect: false },
    plugins: {
      legend: {
        position: "top" as const,
        labels: { color: "#495057", font: { size: 13 }, padding: 16 },
      },
    },
    scales: {
      x: {
        ticks: { color: "#6c757d", font: { size: 11 } },
        grid: { color: "#f3f4f6" },
      },
      y: {
        min: 0,
        ticks: { color: "#6c757d" },
        grid: { color: "#f3f4f6" },
        title: { display: true, text: "Sessions", color: "#6c757d" },
      },
    },
  }), []);

  return (
    <Dialog
      header="Charging Sessions — Trend"
      visible={visible}
      onHide={onHide}
      style={{ width: "90vw", maxWidth: "1100px" }}
      modal
      dismissableMask
    >
      <Chart
        type="line"
        data={chartData}
        options={chartOptions}
        style={{ height: "460px" }}
      />
    </Dialog>
  );
};

export default SessionsDetailDialog;
